import { API_TYPE } from '@umu/umu-fetch';

const GET_STUDENT_POINTS_DETAIL_INFO = {
    url: `/api/points/getstudentpoints`, // 获取学员对应小节积分
    type: API_TYPE.GET,
};
const SET_STUDENT_POINTS = {
    url: `/api/points/addspecialpoints`, // 设置学院特别认可积分
    type: API_TYPE.POST,
};
export const STUDENT_DATA = {
    SET_STUDENT_POINTS,
    GET_STUDENT_POINTS_DETAIL_INFO,
};
